import styled from '@emotion/styled';

export const Container = styled.div`
    position: relative;
    min-height: 100%;
    padding-bottom: 1em;
`;
